import React, { createContext, useContext, ReactElement, ReactNode } from 'react';
import { Tracker } from '../Tracker';
import { useTracking, useTrackingProps } from '../hooks/useTracking';

export const TrackingContext = createContext<TrackingContext>({ tracker: new Tracker() });

export type TrackingContext = {
  tracker: Tracker;
};

export interface TrackingProviderProps extends useTrackingProps {
  shouldInheritFromParentContexts?: boolean;
  children: ReactNode;
}

export const TrackingProvider = ({
  shouldInheritFromParentContexts = false,
  children,
  trackPageLoad,
  prefix,
  context,
  group,
  category,
  pageType,
  getCustomerTrackingData,
  ...extraData
}: TrackingProviderProps): ReactElement<TrackingContext> => {
  const { tracker: parentTracker } = useTrackingContext();
  const { tracker } = useTracking({
    trackPageLoad,
    getCustomerTrackingData,
    pageType,
    prefix: prefix !== undefined ? prefix : shouldInheritFromParentContexts ? parentTracker.prefix : undefined,
    context: context !== undefined ? context : shouldInheritFromParentContexts ? parentTracker.context : undefined,
    group: group !== undefined ? group : shouldInheritFromParentContexts ? parentTracker.group : undefined,
    category: category !== undefined ? category : shouldInheritFromParentContexts ? parentTracker.category : undefined,
    ...(shouldInheritFromParentContexts ? parentTracker.extraData : {}),
    ...extraData,
  });

  return <TrackingContext.Provider value={{ tracker: tracker }}>{children}</TrackingContext.Provider>;
};

export const useTrackingContext = (): TrackingContext => {
  return useContext(TrackingContext);
};
